export const AUTH_TOKEN_KEY = 'AUTH_TOKEN'
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN'
export const USER_NAME_KEY = 'USER_NAME'
export const EXTENT_KEY = 'EXTENT'
export const RESOURCES_KEY = 'RESOURCES_KEY'
export const USER_OPTIONS = 'USER_OPTIONS'
